var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6H10V2H6v4H3.333L8 10.667zm-9.334 6v1.333h9.334V12z",
    fill: "#815500"
  })));
}
export default SvgDownloadIcon;